// @ts-ignore
import { loadDependencyUrls } from "@theopenweb/js-functions/src/base-utility";

/**
* @see https://web.dev/codelab-two-ways-to-prefetch/
* @param {string} url
*/
export function injectLinkPrefetchIn4g(url) {
    const networkInformation = /** @type {NetworkInformation & { effectiveType: string }} */ (window.navigator.connection) // Because typing not working properly.
    if (networkInformation.effectiveType === '4g') {
        //generate link prefetch tag
        const linkTag = document.createElement('link');
        linkTag.rel = 'prefetch';
        linkTag.href = url;
        linkTag.as = 'document';

        //inject tag in the head of the document
        document.head.appendChild(linkTag);
    }
}


/**
 * @see https://stackoverflow.com/a/15150779/1764521
 */
export function hidePrintHeaderAndFooter() {
    return `
    @media print {
      @page { margin: 0; }
      body { margin: 1.6cm; }
    }
    `
}

/**
* @param {string[]} selectors
*/
export function hideOnPrint(selectors) {
    return `
    @media print {
      ${selectors.join(',')} {
        display: none!important;
        position: absolute!important;
        top: -9999px!important;
        left: -9999px!important;
        visibility: hidden!important;
      }
    }
    `
}

/**
 * @param {string} css
 */
export function printCss(css) {
    return `@media print{
      ${css}
    }`
}

/**
 * @param {string} src
 */
export const createIframe = (src) => {
    const iframe = document.createElement('iframe')
    iframe.src = src
    return iframe
}

/**
 * @param {string} selector 
 */
export function safeQuerySelector(selector) {
    const element = document.querySelector(selector)
    if (!element) throw new Error('No element')
    return element
}

/**
 * @param {string} paramName 
 */
export function getURLFromQuery(paramName) {
    const urlObj = new URL(window.location.href)
    const paramValue = urlObj.searchParams.get(paramName)
    if (!paramValue) return null
    return window.decodeURIComponent(paramValue)
}

/**
* Easy to use utility function for loading multiple files.
* @param {string[]} filesList
* @param {string} [base]
*
* @see https://github.com/theopenwebjp/js-functions/blob/master/src/base-utility.js#L1057 loadDepndencyUrls
*/
export async function loadFiles(filesList, base = '') {
    return await Promise.all(
        [
            loadDependencyUrls(
                filesList.map(f => `${base}${f}`)
            )
        ]
    )
}
